/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { McaLightProvider, StringProvider } from "../types";

export function isStringProvider(value: unknown): value is StringProvider {
  return Object.values(McaLightProvider).includes(value as McaLightProvider);
}
